import dayjs from 'dayjs';

import { OverlayBanner } from '@/shared/components/overlay-banner';
import { CampaignOverviewSkeleton } from './campaign-overview-skeleton';

interface Props {
  scheduledStartDate: string;
}

export function CampaignDetailScheduledState({ scheduledStartDate }: Props) {
  return (
    <section className="relative min-h-full">
      <CampaignOverviewSkeleton />

      <div
        aria-hidden="true"
        className="bg-background/40 absolute inset-0 top-0 left-0 rounded-[inherit] backdrop-blur-xs"
      />

      <OverlayBanner
        title={`Tracking starts on ${dayjs(scheduledStartDate).add(1, 'day').format('MMM D, YYYY')}`}
        description="Overview, creator, and post insights will unlock after kickoff. You can still review the setup from the header while this campaign is waiting to start."
        className="inset-0 z-10 flex items-center justify-center px-4 py-10 sm:px-8"
      />
    </section>
  );
}
